import { SHIPPING_OPTION_FREE } from '../../stores/shippingStore/shipping.consts'
import { type CheckoutSummary } from '../../components/Pricing/types/checkout.types'
import { type GroupPricingResult } from './groupCheckoutPricing.types'

// Group pricing answers only the parts of a summary that a shipping option
// changes; everything tile-level comes from the base summary it's applied to.
export function applyGroupShippingOptionToSummary(
  pricingSummary: CheckoutSummary,
  groupPricing: GroupPricingResult,
  optionKey: string
): CheckoutSummary {
  const shippingOption =
    groupPricing.shippingOptions[optionKey] ??
    groupPricing.shippingOptions[SHIPPING_OPTION_FREE]
  if (!shippingOption) return pricingSummary

  const groupTax = shippingOption.taxesDetailed.reduce(
    (sum, taxDetail) => sum + taxDetail.amount,
    0
  )

  return {
    ...pricingSummary,
    checkoutId: groupPricing.checkoutId,
    totalPrice: shippingOption.totalPrice,
    priceBeforeTax: shippingOption.priceBeforeTax,
    productTotalPrice: groupPricing.productTotalAfterDiscount,
    productTotalPriceBeforeDiscount: groupPricing.productTotalBeforeDiscount,
    shippingCost: shippingOption.shippingCost,
    shippingCostBeforeDiscount: shippingOption.shippingCostBeforeDiscount,
    creditUsed: shippingOption.creditUsed,
    isEligibleFreeShipping: shippingOption.isEligibleFreeShipping,
    currency: groupPricing.currency,
    tax: groupTax,
    taxesDetailed: shippingOption.taxesDetailed,
    products: groupPricing.products,
    totalItems: groupPricing.products.length,
    giftCardCreditItems: shippingOption.giftCardCreditItems,
    giftsBalances: shippingOption.giftsBalances ?? [],
  }
}
